// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__1tRBb","rotate":"styles_rotate__11nQZ","divloading":"styles_divloading__2JPLu"};